import { supabase } from "~/integrations/supabase/ssr.browser";
import { clearBaaNudgeSessionKeys } from "~/lib/baa-nudge-session";

// AIDEV-NOTE: Logout does client-side signOut first (clears local session/listeners),
// then navigates to /logout route for server-side cookie cleanup and redirect.
export async function handleLogout() {
    clearBaaNudgeSessionKeys();
    await supabase.auth.signOut();
    window.location.href = "/logout";
}
